<template>
  <div>
    <v-card color="mt-3 pa-2 primary darken-1">
      <v-card-title v-if="periodDate" class="mb-0">
        <v-row class="px-3 mt-2" align="center">
          <v-icon size="16" class="mr-1" color="white">mdi-calendar-outline</v-icon>
          <h6 id="period-date-title" class="white--text">Dados de {{formatDate(periodDate.period[0])}} a {{formatDate(periodDate.period[1])}}</h6>
        </v-row>
      </v-card-title>
      <v-card-title class="mb-0">
        <chart-header
          :authorize="authorize"
          @fullscreenChart="fullscreenChart"
          @printChart="printChart"
          @exportChart="exportChart($event)"
          @exportCSV="exportCSV"
          @exportXLS="exportXLS"
        >
          <template v-slot:title>
            Variação do volume
          </template>
        </chart-header>
      </v-card-title>

      <v-card-text >
        <h3 class="subtitle-1 white--text">Selecione o tipo do dado</h3>
        <v-tabs class="hidden-sm-and-down secondary--text text--lighten-1" v-model="tab" active-class="secondary lighten-1 primary--text text--darken-1" background-color="primary darken-1" slider-color="secondary lighten-1">
          <v-tab class="tab-item-title" v-for="(item, index) in items" :key="index" :id="item.id">
            {{item.title}}
            <v-tooltip v-if="item.showVolumePercentageTooltip" top color="primary darken-1">
              <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                <v-icon
                  right
                  small
                  class="ml-1"
                  :color="volumePercentageTooltipIconColor(index)"
                  v-bind="tooltipAttrs"
                  v-on="tooltipOn"
                >
                  mdi-help-circle-outline
                </v-icon>
              </template>
              <span class="volume-percentage-tooltip">
                {{ volumePercentageTooltipMessage }}
              </span>
            </v-tooltip>
          </v-tab>
        </v-tabs>

        <v-menu
            bottom
            left
          >
              <template v-slot:activator="{ on, attrs }">
                <v-btn

                  class="hidden-md-and-up tab-item-title tranparent"
                  outlined
                  v-bind="attrs"
                  v-on="on"
                >
                  {{items[tab].title}}
                  <v-tooltip v-if="items[tab].showVolumePercentageTooltip" top color="primary darken-1">
                    <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                      <v-icon
                        small
                        class="ml-1"
                        :color="volumePercentageTooltipIconColor(tab)"
                        v-bind="tooltipAttrs"
                        v-on="tooltipOn"
                      >
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span class="volume-percentage-tooltip">
                      {{ volumePercentageTooltipMessage }}
                    </span>
                  </v-tooltip>
                  <v-icon >
                    mdi-menu-down
                  </v-icon>
                </v-btn>
              </template>

              <v-list>
                 <v-list-item v-for="(item, index) in items" :key="index" @click="changeTabItem(index)">
                  {{item.title}}
                </v-list-item>
              </v-list>
          </v-menu>

        <v-tabs-items v-model="tab" class="primary darken-1" touchless>
          <v-tab-item
            class="px-0"
            key="tab-volume-hm3"
          >
            <v-card flat color="primary darken-1">
                <v-card-text class="px-0 text-center" >
                  <useful-volume-chart
                    ref="usefulVolumeChart"
                    :idChart="`volume-container-chart-${tabName}`"
                    :periodDate="periodDate"
                    :volumeData="usefulVolume"
                    :basin="basin"
                    @chartRenderComplete="chartRenderComplete($event)"
                  >
                  </useful-volume-chart>

                </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
            key="tab-volume-percentage"
          >
            <v-card flat color="primary darken-1">
              <v-card-text >
                <useful-volume-chart
                  ref="usefulVolumeChartPercentage"
                  :idChart="`volume-container-chart-percentage-${tabName}`"
                  :periodDate="periodDate"
                  :volumeData="usefulVolumePercentage"
                  :basin="basin"
                  unitMeasurement="%"
                  @chartRenderComplete="chartRenderCompletePercentage($event)"
                >
                </useful-volume-chart>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment';
import Highcharts from "highcharts";
import Exporting from 'highcharts/modules/export-data';
import UsefulVolumeChart from '../common/UsefulVolumeChart.vue';
import ChartHeader from '../../common/ChartHeader.vue';
import { usefulVolumeChartAuthorization, usefulVolumePercentageChartAuthorization } from '../../../helpers/chart_export_authorization';
Exporting(Highcharts)
export default {
  name: 'VolumeCharts',
  props:['periodDate', 'basin', 'tabName', 'usefulVolume', 'usefulVolumePercentage'],
  components:{
    UsefulVolumeChart,
    ChartHeader
  },
  data:()=>({
    tab: 0,
    chartRendered: undefined,
    chartRenderedPercentage: undefined,
    items:[
      {
        title: 'Volume (hm³)',
        id: 'tab-volume-hm3'
      },
      {
        title: 'Volume (%)',
        id: 'tab-volume-percentage',
        showVolumePercentageTooltip: true
      }
    ],
    authorize: [],
    volumePercentageTooltipMessage: 'A porcentagem do volume é calculada com base no volume total do reservatório.',
  }),
  created(){
    this.authorize = usefulVolumeChartAuthorization;
  },
  watch:{
    volumesWatch(value){
      if(value){
        this.processData();
      }
    },
    tab(value){
      if(value === 0){
        setTimeout(()=>{
          if (this.$refs.usefulVolumeChart) {
            this.$refs.usefulVolumeChart.chartPreprocessing();
            this.authorize = usefulVolumeChartAuthorization;
          }
        }, 50);
      }
      if(value === 1){
        setTimeout(()=>{
          if (this.$refs.usefulVolumeChartPercentage) {
            this.$refs.usefulVolumeChartPercentage.chartPreprocessing();
            this.authorize = usefulVolumePercentageChartAuthorization;
          }
        }, 50);
      }
    }
  },
  computed:{
    volumesWatch() {
      return [this.usefulVolume, this.usefulVolumePercentage];
    },
    chart(){
      return this.tab === 0 ? this.chartRendered : this.chartRenderedPercentage;
    }
  },
  methods:{
    processData(){
      setTimeout(()=>{
        if (this.$refs.usefulVolumeChart) {
          this.$refs.usefulVolumeChart.chartPreprocessing();
        }
      }, 50);

      setTimeout(()=>{
        if(this.$refs.usefulVolumeChartPercentage){
          this.$refs.usefulVolumeChartPercentage.chartPreprocessing();
        }
      }, 50);
    },
    chartRenderCompletePercentage(chart){
      this.chartRenderedPercentage = chart;
    },
    chartRenderComplete(chart){
      this.chartRendered = chart;
    },
    exportChart(typeFile){
      this.chart.exportChart({type: typeFile});
    },
    exportCSV(){
      this.chart.downloadCSV();
    },
    exportXLS(){
      this.chart.downloadXLS()
    },
    fullscreenChart(){
      const fullscreenControl = new Highcharts.Fullscreen(this.chart);
      fullscreenControl.open();
    },
    printChart(){
      this.chart.print();
    },
    changeTabItem(tabIndex){
      this.tab = tabIndex;
    },
    volumePercentageTooltipIconColor(index){
      return this.tab === index ? 'primary darken-1' : 'secondary lighten-1';
    },
    formatDate(date){
      const stringFormat = this.periodDate.type === 'Diário' ? 'DD/MM/YYYY' : 'MMMM/YYYY';
      return moment(date).locale('pt-br').format(stringFormat);
    },
  }
}
</script>

<style scoped>
  .tab-item-title{
    color: var(--v-secondary-lighten1) !important;
    border: 1px solid var(--v-secondary-lighten1);
    text-transform: none;
  }
  #tab-volume-hm3{
    border-radius: 4px 0px 0px 4px;
  }
  /* #tab-rain-level{

  } */
  #tab-volume-percentage{
    border-radius: 0px 4px 4px 0px
  }

  #period-date-title{
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
  }

  .volume-percentage-tooltip{
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 0.875rem;
    line-height: 18px;
  }
</style>
